import * as R from 'ramda';
import React, { Fragment } from 'react';
import {withRouter} from 'react-router-dom';

import {pathHome, pathPrivacyPolicy} from 'iss/paths';
import {translate} from 'iss/strings';
import {fetchParty, login} from 'iss/service/PartyService';
import styles from 'iss/styles/LoginForm.styl';
import * as aad from 'iss/utils/azureAd';
import {SubmitButton} from 'iss/widgets/Buttons';
import {FormWithState, Input} from 'iss/widgets/Forms';
import {ErrorBox} from 'iss/widgets/MessageBox';
import BootstrapButton from 'iss/widgets/bootstrap/Button';
import validators, {withError} from 'iss/widgets/form/validation/validators';

const LoginForm = withRouter(class extends React.Component {
  state = {
    backendError: null,
    aadError: null,
    inProgress: false
  };
  loginSubscription = null;

  errorReasonByMessage = new Map([
    ['bad credentials', translate('loginForm.wrongCredentials')],
    ['wrong credentials', translate('loginForm.wrongCredentials')],
    ['user credentials have expired', translate('loginForm.credentialsExpired')],
    ['user account has expired', translate('loginForm.accountExpired')],
    ['user account is locked', translate('loginForm.accountLocked')],
    ['user is disabled', translate('loginForm.accountDisabled')],
    ['invalid user information', translate('loginForm.invalidUserInfo')],
    ['invalid role', translate('loginForm.invalidRole')],
    ['unknown azure ad user', translate('loginForm.unknownAadUser')],
    ['interaction_in_progress', translate('loginForm.aadInteractionInProgress')],
    ['user_cancelled', translate('loginForm.userCancelled')],
  ]);

  componentWillUnmount() {
    if (this.loginSubscription != null) {
      this.loginSubscription.unsubscribe();
    }
  }

  render() {
    return <div className={styles.loginFormContainer}>
      <h1>{translate('loginForm.title')}</h1>
      <div className={styles.azureAdLogin}>
        <SubmitButton id="azureAdLogin" disabled={this.state.inProgress} onClick={this.azureSignIn}>
          {translate('loginForm.loginWithAzureAd')}
        </SubmitButton>
        {this.state.aadError &&
          <ErrorBox message={this.state.aadError} />
        }
      </div>
      <div className={styles.methodSeparator}>{translate('loginForm.loginAsExternalUser')}</div>
      <FormWithState onSubmit={this.login}>
        <Input label="loginForm.username" id="username" valuePath="username" validate={withError('loginForm.emptyUsername', validators.required)}  />
        <Input label="loginForm.password" id="password" valuePath="password" validate={withError('loginForm.emptyPassword', validators.required)} type="password" />
        <ErrorBox message={
          this.state.errorLink == undefined ? (
            this.state.backendError
          ) : (
            errorFragmentWithLink(this.state.backendError, this.state.errorLink)
          )
        } />
        <SubmitButton id="login" text={translate('loginForm.login')} disabled={this.state.inProgress} />
        <div>
          <BootstrapButton buttonLook="link" target="_blank" className={styles.privacyPolicy} disabled={this.state.inProgress}
              href={pathPrivacyPolicy} component="a" text={translate('loginForm.downloadPrivacyPolicy')} />
        </div>
      </FormWithState>
    </div>;
  }

  azureSignIn = async () => {
    this.setState({inProgress: true});
    try {
      if (!aad.isSignedIn()) {
        await aad.signIn();
      }
      await fetchParty().toPromise();
      this.setState({inProgress: false});
      this.props.history.push(pathHome);
    } catch (err) {
      this.setState({aadError: this.getLoginErrorMessage(err)});
      if (err.errorCode !== 'user_cancelled') {
        await aad.signOut();
      }
      this.setState({inProgress: false});
    }
  };

  login = ({username, password}) => {
    this.setState({inProgress: true});
    this.loginSubscription = login(username, password).subscribe(() => {
      this.setState({inProgress: false});
      this.props.history.push(pathHome);
    }, this.onLoginError);
  };

  onLoginError = (err) => {
    this.setState({inProgress: false});
    if (err.statusCode === 401) {

        if (err.message == "User credentials have expired") {
          this.setState({
            backendError: translate('loginForm.expiredPassword'),
            errorLink: {url: 'https://login.issworld.com/adfs/portal/updatepassword/', name: 'login.issworld.com'}
          });
        } else {
          this.setState({backendError: this.getLoginErrorMessage(err), errorLink: undefined});
        }

    } else {
      this.setState({backendError: translate('loginForm.unknownError'), errorLink: undefined});
    }
  };

  getLoginErrorMessage = (err) => {
    if (!R.isNil(err.data) && !R.isNil(err.data.message)) {
      const message = this.errorReasonByMessage.get(err.data.message.toLowerCase());
      return R.isNil(message) ? this.getErrorMessage(err) : message;
    } else if (!R.isNil(err.errorCode)) {
      const message = this.errorReasonByMessage.get(err.errorCode.toLowerCase());
      return R.isNil(message) ? this.getErrorMessage(err) : message;
    } else if (!R.isNil(err.message)) {
      const message = this.errorReasonByMessage.get(err.message.toLowerCase());
      return R.isNil(message) ? this.getErrorMessage(err) : message;
    }
    return this.getErrorMessage(err);
  };

  getErrorMessage = (err) => {
    if (!R.isNil(err.message) && err.message !== '') {
      return translate('loginForm.unknownSpecificError', {message: err.message});
    }
    return translate('loginForm.unknownError');
  };
});

function errorFragmentWithLink(message, link) {
  // Apparrently HTML tags cannot be used in translation strings (without applying dirtyish hacks) so instead
  // expect that message contains the marker '<>' that is used to split the string into two parts and
  // between those add the link element.
  const parts = message.split('<>');
  return (
    <Fragment>
        {parts[0]}
        <a href={link.url}>{link.name}</a>
        {parts[1]}
    </Fragment>
  );
}

export default LoginForm;



// WEBPACK FOOTER //
// ./modules/issFrontend/pages/LoginForm.jsx